import PropTypes from 'prop-types';

// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';

//
import AccountPopover from './AccountPopover';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
import FavoritePopover from './favorites/favoritePopover';
import LanguagePopover from '../../../components/LanguagePopover';
import NotificationsPopover from './notifications/notificationsPopover';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;
const NAV_WIDTH_REDUCED = 80;

const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
  isExpanded: PropTypes.bool, // <-- new prop
};

export default function Header({ onOpenNav, isExpanded }) {
  return (
    <StyledRoot
      sx={(theme) => ({
        [theme.breakpoints.up('lg')]: {
          width: `calc(100% - ${(isExpanded ? NAV_WIDTH : NAV_WIDTH_REDUCED) + 1}px)`,
        },
      })}
    >
      <StyledToolbar>
        {/* Mobile menu button */}
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1 }}>
          <FavoritePopover />
          <LanguagePopover />
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
